// Event Detail Tabs -- iteration 082

export const EVENT_BLOCK_TYPES = [
  "location",
  "roster",
  "travel",
  "clothing",
  "warmup",
  "streaming",
  // 196 -- gate/arrival times and accommodation as first-class block types
  // (bus schedules ride the existing "travel" type).
  "arrival",
  "accommodation",
  "custom",
] as const;
export type EventBlockType = (typeof EVENT_BLOCK_TYPES)[number];

export const POLL_TYPES = ["single_choice", "multi_choice", "volunteer_signup", "yes_no"] as const;
export type PollType = (typeof POLL_TYPES)[number];

export interface PollOption {
  label: string;
  value: string;
  max_signups?: number | null;
}

export interface EventDetailBlockPublic {
  id: string;
  event_id: string;
  block_type: EventBlockType;
  title: string;
  body: string | null;
  meta: Record<string, unknown>;
  sort_order: number;
  visible: boolean;
  created_at: string;
  updated_at: string;
}

export interface EventDetailBlockListResponse {
  blocks: EventDetailBlockPublic[];
  _actions: { can_edit: boolean };
}

export interface PollOptionTally {
  value: string;
  label: string;
  max_signups: number | null;
  count: number;
  responders: Array<{ user_id: string; display_name: string | null; note: string | null }>;
}

export interface EventPollPublic {
  id: string;
  event_id: string;
  question: string;
  poll_type: PollType;
  options: PollOption[];
  closes_at: string | null;
  closed_at: string | null;
  created_by: string;
  creator_display_name: string | null;
  created_at: string;
  updated_at: string;
  tally: PollOptionTally[];
  my_votes: string[];
  _actions: { can_edit: boolean; can_close: boolean; can_respond: boolean };
}

export interface EventPollListResponse {
  polls: EventPollPublic[];
  _actions: { can_create: boolean };
}
